import(/* webpackMode: "eager" */ "/workspace/src/app/global-error.tsx");
